<template>
  <el-dialog
    :title="title"
    :visible="visible"
    width="30%"
    @close="close"
    left
  >
    <slot></slot>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "option-dialog",
  props: {
    title: {
      type: String,
    },
    visible: {
      type: Boolean,
    }
  },
  data() {
    return {
      _visible: false,
    };
  },
  computed: {
    dvisible: {
      set: function(value) {
        this._visible = value;
      },
      get: function() {
        return this.visible;
      },
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    submit() {
      this.$emit("submit");
    },
  },
};
</script>

<style lang="scss" scoped></style>
